import { render, staticRenderFns } from "./PerksView.vue?vue&type=template&id=0461b76e"
import script from "./PerksView.vue?vue&type=script&lang=js"
export * from "./PerksView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports